<template>
    <div class="tl-section" :style="isInquiry ? 'border: none; padding:0;' : ''">
        <div class="tl-row">
            <div v-if="!isInquiry" class="tl-columnheader">
                <h2 class="tl-tit">선택한 스타일 <span class="color-red">*</span></h2>
            </div>
            <div class="tl-cell" :style="isInquiry ? 'padding:0;' : ''">
                <div class="estimate-style">
                    <div class="es-left">
                        <div class="es-img" :style="`background-image:url(${item.thumb});`"></div>
                    </div>
                    <div class="es-right">
                        <h3 class="es-tit">{{ item.subject }}</h3>
                        <p class="es-txt">{{ item.category }} · {{ item.acreage + "평" }} · {{ item.company }}</p>
                        <a href="#" class="es-link" @click="goDetail">자세히 보기 &nbsp; &gt;</a>
                        <div v-if="!isInquiry" class="es-btn-wrap">
                            <a href="#" class="button button--border-primary" @click="goEstimate">시공 견적서 보기</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        portfolio: Object,
        _parents: Array,
        isInquiry: { type: Boolean, default: false }, // 견적요청서 결과페이지
    },
    data() {
        return {
            item: {
                thumb: "",
                subject: "",
                category: "",
                acreage: "",
                company: "",
            },
            detailPath: "",
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.item = {
                thumb: this.portfolio?.thumb,
                subject: this.portfolio?.subject,
                category: this.portfolio?.category?.name,
                acreage: this.portfolio?.construction?.acreage,
                company: this.portfolio?.user?.company?.name,
            };

            let path = "/portfolio/";

            const parents = this.portfolio?.category?.parents;
            let parent = undefined;
            if (parents?.length) parent = this._parents.find(({ _id }) => _id === parents[0])?._id;
            else parent = this.portfolio?.category?._id;
            switch (parent) {
                case "5fae46e6dc19c41f74a85f04":
                    path += "resident";
                    break;
                case "5fae50b7dc19c41f74a85f05":
                    path += "industry";
                    break;
                case "5fae50c7dc19c41f74a85f06":
                    path += "partial";
                    break;
                default:
                    path += "resident";
            }
            path += "/";
            path += this.portfolio?._id;

            this.detailPath = path;
        },
        goDetail(event) {
            event.preventDefault();
            let route = this.$router.resolve({ path: this.detailPath });
            window.open(route.href, "_blank");
        },
        goEstimate(event) {
            event.preventDefault();
            this.$emit("go-estimate");
        },
    },
};
</script>
